import { render, staticRenderFns } from "./class-compare.vue?vue&type=template&id=394c4d5d&scoped=true"
import script from "./class-compare.vue?vue&type=script&lang=js"
export * from "./class-compare.vue?vue&type=script&lang=js"
import style0 from "./class-compare.vue?vue&type=style&index=0&id=394c4d5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394c4d5d",
  null
  
)

export default component.exports